import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL || "";
const sameOrigin = !envBase || (typeof window !== "undefined" && new URL(envBase).origin === window.location.origin);
const API = `${sameOrigin ? (typeof window !== "undefined" ? window.location.origin : "") : envBase}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pl_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
